import { Outlet } from "@tanstack/react-router";
import { SidebarProvider, SidebarInset } from "@corpuscomplete/web-ui/components/sidebar";
import { AppSidebar } from "@corpuscomplete/web/components/app-sidebar";
import { ZeroInit } from "@corpuscomplete/web/components/zero-init";

export function AuthenticatedShell() {
  return (
    <SidebarProvider className="h-svh max-h-svh overflow-hidden">
      <AppSidebar />
      <SidebarInset className="overflow-hidden">
        <ZeroInit>
          <Outlet />
        </ZeroInit>
      </SidebarInset>
    </SidebarProvider>
  );
}
